"use client";

import { Flex, Text } from "@chakra-ui/react";

const w = "100%";

export const CardDownload = ({ label, type, selected }) => {
  return (
    <Flex
      color={"white"}
      borderRadius={"0.5rem"}
      bg={"primary"}
      overflow={"hidden"}
      borderColor={selected ? "blue" : "white"}
      borderWidth={"4px"}
      w={w}
      // alignSelf={"flex-start"}
      // maxW={'25rem'}
      // flex={1}
      // w={'100%'}
    >
      <Text
        w={w}
        overflow={"hidden"}
        textAlign={"left"}
        p={"1rem"}
        textStyle={"md"}
        textWrap={'nowrap'}
      >
        {label}
      </Text>
      <Flex justify={"space-between"} direction={"column"}>
        <Flex p={"0.5em"}></Flex>
        <Flex bg={"fontdark"} borderTopLeftRadius={"3rem"} p={"0.4em"}>
          <Text textStyle={"sm"}>.{type}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
